import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

// yyyy
const mask = [/\d/, /\d/, /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    pipe: createAutoCorrectedDatePipe('yyyy'),
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
